import tax from '@/api/hr/tax-range'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  taxId: 0
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_TAX_ID(state, taxId) {
    state.taxId = taxId
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        taxId: context.state.taxId
      },
      attributes
    )
    return tax.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return tax.store(data)
  }
}
